import { createContext, useContext } from "react";
import { ContextValueType } from "./types";

export const Context = createContext<ContextValueType | undefined>(undefined);

const useAuth = (): ContextValueType => {
  const context = useContext(Context);

  if (!context) {
    throw new Error("useAuth must be used within a AuthProvider");
  }

  return context;
};

export default useAuth;
